module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-1-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("1")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Edinburgh, Scotland")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("A")]), _vm._v(" sudden gust of wind rattled rain like pellets against the bedroom window. The room flickered briefly as lightning flashed over the city. Thunder rumbled overhead and twelve-year-old Alex Fleming woke up suddenly. He shot up in bed with his eyes wide open. But it wasn’t the sound of the rain or the thunder that alarmed him. It was a man’s voice downstairs, loud and aggressive. No one had been with his mother when Alex came to bed and she hadn’t said she was expecting anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He pulled the bedclothes back and swung his legs over the edge of the bed. The bedroom door was slightly ajar and a dim light shone in from the landing. He crept towards the door and pushed it open. The man’s voice was louder.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Alex made his way quietly along the landing and peered down the stairs. He took a deep breath and crept down. At the foot of the stairs, he looked warily along the hallway that ran from the front door to the kitchen. The kitchen door was wide open and he could see his mother trying to wrestle away from the grip of the man. Alex recognised him. It was Jimmy Calder who worked in the small corner-street shop with Alex’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Let me go!’ she was demanding.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Calder ignored her and tightened his grip. ‘The police came to see me,’ he snarled. ‘They seem to think I took the money from the till. You told them it was me, didn’t you, Anne?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, I didn’t!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But you said it wasn’t you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anne nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So, you might just as well have said it was me. Apart from that bitch of an owner, Morag bloody Campbell, there’s only the two of us that work in the shop.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What else was I supposed to say?’ Anne mumbled, trying to pull away from Calder.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You could have told them the same as me and that a customer could have nicked it from the till when we weren’t looking.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s not what happened though.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll tell you what’s"), _c('i'), _vm._v("going to happen. You’re going to say you took it–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But I didn’t! I can’t own up to something I didn’t do,’ Anne protested.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I need you to help me out here, Anne.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What do you mean?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Did you know I was in prison before I came to work in the shop?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, no I didn’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I was and I’m out on parole. If they nick me for this, I’ll be back inside.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I… I didn’t know–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, and there’s no way that’s going to happen because you’re going to say it was you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I can’t!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Shut up and listen! You don’t have a criminal record. You’re a single mother with a young son. If you plead guilty, say you only intended to borrow the money to pay the rent and that you’re sorry, you won’t get a custodial sentence.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I won’t do it–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Calder grabbed Anne’s hair and pulled her head back, making her scream. He thrust his face close to hers. ‘Oh yes you will,’ he hissed through clenched teeth. ‘I can get some friends of mine to pay you a visit if I go back to prison. They can be nasty pieces of work if I want them to be.’ Calder tugged harder on Anne’s hair. ‘Pity if anything happened to your son. Know what I mean?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You bastard!’ Anne yelled in a sudden fit of rage. She thrust a knee into Calder’s groin. He gasped and staggered backwards, catching his hand against the blade of a carving knife sticking out from a drying rack. He cursed and watched blood seeping out between his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sorry… sorry,’ Anne stammered.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You bitch!’ Calder screamed. He grabbed the knife and thrust it upwards into Anne’s stomach. A red stain seeped through her white shirt. Her eyes opened wide as she staggered backwards.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Alex screamed, ‘Mum!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anne looked over Calder’s shoulder and saw Alex trembling at the end of the hallway. ‘Run, run!’ she yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Calder turned and saw Alex, his face twisting into a snarl as he rushed towards the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Run!’ Anne screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Alex turned and ran for the front door. He yanked it open as he heard the harsh thump of feet and heavy breathing behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Come back here!’ Calder shouted. But Alex didn’t stop. He ran outside, pulling the front door closed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Calder cursed as he crashed into it. ‘Fuck!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Alex didn’t look back. He was down the steps and across the short path to the pavement. Freezing rain battered his face like shards of ice. Lightning flashed across the dark sky and thunder crashed overhead. Alex tried to blink the rain from his eyes as he turned right, lungs exploding as he ran as fast as his legs would carry him. His bare feet felt as though he was running on broken glass, but he daren’t stop.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Calder was catching up with him as Alex reached the end of the street. He was deciding whether to turn right or cross the road when he saw a car coming. Thinking quickly, he thought he might just be able to get across the road in front of the car and that would hold Calder up for a few seconds. He could then turn into the maze of streets on the other side and lose him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Without giving it another thought, Alex ran straight onto the road. Headlights pierced through the rain. He’d misjudged the speed of the car completely. Alex heard the squeal of tyres and saw the headlights too close. The car skidded and hit Alex, tossing him into the air off the bonnet. He hit the ground and lay still in the middle of the road.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The car doors flew open and the driver and passenger rushed round to Alex. The driver’s face was ashen. ‘I… I couldn’t stop in time,’ he stammered. ‘He… he appeared from nowhere and ran straight in front of us.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The passenger had taken control. ‘Ambulance! Ring for an ambulance! Quick! I can feel a pulse.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The driver was hysterical. ‘Thank God!’ He tried to get his mobile phone out of his pocket, but his hands were shaking so much that he dropped it on the road. The passenger grabbed it and made the call.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Alex could hear voices. His vision was blurred. He could see bright lights and felt nothing but the cold rain falling heavily on his face. Two people were bending over him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Beyond them he could make out the dark shape of Calder standing on the edge of the pavement, watching. Alex tried to say something, but no words came out. The last thing he saw was Calder turning and melting into the shadows.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e09b994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter001.vue
// module id = 75
// module chunks = 0